// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__hEi-8","subheader":"ReorderModal_subheader__9116t","listWrap":"ReorderModal_listWrap__3KUDM"};